import { directors } from "@/mocks/directors";
import SectionHeading from "./SectionHeading";

export default function DirectorSection() {
  return (
    <section id="directors" className="w-full bg-background-100 py-16 md:py-24 scroll-mt-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="Directors & schools"
          title="导演与流派：同一议题的四种讲述方式"
          desc="伦理题材在不同地域长出了不同的样子。了解它们各自的偏好，能帮你更快判断一部作品的味道。"
        />

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5">
          {directors.map((d) => (
            <div
              key={d.id}
              className="flex flex-col rounded-lg bg-background-50 border border-background-200/70 p-6 md:p-7"
            >
              <div className="flex items-start justify-between gap-4">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950">
                  {d.name}
                </h3>
                <span className="shrink-0 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 font-label text-xs whitespace-nowrap">
                  {d.region}
                </span>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-foreground-700">{d.style}</p>
              <div className="mt-5 pt-4 border-t border-background-200/70 flex items-start gap-2.5">
                <i className="ri-bookmark-3-line text-primary-600 text-base mt-0.5"></i>
                <span className="text-xs md:text-sm leading-relaxed text-foreground-600">{d.works}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}